"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const TreeView_1 = __importDefault(require("@material-ui/lab/TreeView"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const TreeItem_1 = __importDefault(require("@material-ui/lab/TreeItem"));
const Link_1 = __importDefault(require("../Link"));
const useStyles = styles_1.makeStyles({
    root: {
        flexGrow: 1,
    },
});
const renderTree = (node) => {
    var _a;
    const TreeItemLink = node.url ? (react_1.default.createElement(Link_1.default, { href: node.url, target: "_blank" }, node.label)) : (`${node.label} ${((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) ? `(${node.children.length})` : ''}`);
    return (react_1.default.createElement(TreeItem_1.default, { classes: node.classes, key: node.id, nodeId: node.id, label: TreeItemLink }, node.children && Array.isArray(node.children) ? node.children.map((child) => renderTree(child)) : null));
};
/** A tree view is useful for displaying hierarchical or grouped structures such as a file system. */
const TreeView = (_a) => {
    var { root, defaultExpanded, onNodeSelect, onNodeToggle, defaultSelected, multiSelect } = _a, props = __rest(_a, ["root", "defaultExpanded", "onNodeSelect", "onNodeToggle", "defaultSelected", "multiSelect"]);
    const classes = useStyles();
    const [expanded, setExpanded] = react_1.default.useState(defaultExpanded || []);
    const [selected, setSelected] = react_1.default.useState(defaultSelected || []);
    const handleToggle = react_1.useCallback((event, nodeIds) => {
        setExpanded(nodeIds);
        onNodeToggle === null || onNodeToggle === void 0 ? void 0 : onNodeToggle(event, nodeIds);
    }, [setExpanded, onNodeToggle]);
    const handleSelect = react_1.useCallback((event, nodeIds) => {
        setSelected(nodeIds);
        onNodeSelect === null || onNodeSelect === void 0 ? void 0 : onNodeSelect(event, nodeIds);
    }, [setSelected, onNodeSelect]);
    const testId = props['data-testid'] || 'tree-view';
    return (react_1.default.createElement(TreeView_1.default, { className: classes.root, defaultExpanded: defaultExpanded, defaultCollapseIcon: react_1.default.createElement(ExpandMore_1.default, null), defaultExpandIcon: react_1.default.createElement(ChevronRight_1.default, null), onNodeToggle: handleToggle, onNodeSelect: handleSelect, defaultSelected: selected, multiSelect: multiSelect || undefined, expanded: expanded, selected: selected, "data-testid": testId }, renderTree(root)));
};
exports.default = TreeView;
//# sourceMappingURL=index.js.map